export const BuiltInAddresses = {
    mainnet: {
        'nameRegistry:set_child_record': {
            address: 'KT1QHLk1EMUA8BPH3FvRUeUmbTspmAhb7kpd',
        },
        'nameRegistry:update_record': {
            address: 'KT1H1MqmUM4aK9i1833EBmYCCEfkbt6ZdSBc',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1TnTr6b2YxSx2xUQ8Vz3MoWy771ta66yGx',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1J9VpjiH5cmcsskNb8gEXpBtjD4zrAx4Vo',
        },
        nameRegistry: {
            address: 'KT1F7JKNqwaoLzRsMio1MQC7zv3jG9dHcDdJ',
            resolveProxyContract: true,
        },
        'tldRegistrar:tez:commit': {
            address: 'KT1P8n2qzJjwMPbHJfi4o8xu6Pe3gaU3u2A3',
        },
        'tldRegistrar:tez': {
            address: 'KT1P8n2qzJjwMPbHJfi4o8xu6Pe3gaU3u2A3',
            resolveProxyContract: true,
        },
        'tldRegistrar:tez:buy': {
            address: 'KT191reDVKrLxU9rjTSxg53wRqj6zh8pnHgr',
        },
        'tldRegistrar:tez:renew': {
            address: 'KT1EVYBj3f1rZHNeUtq4ZvVxPTs77wuHwARU',
        },
        'tldRegistrar:tez:bid': {
            address: 'KT1CaSP4dn8wasbMsfdtGiCPgYFW7bvnPRRT',
        },
        'tldRegistrar:tez:withdraw': {
            address: 'KT1CfuAbJQbAGYcjKfvEvbtNUx45LY5hfTVR',
        },
        'tldRegistrar:tez:settle': {
            address: 'KT1MeFfi4TzSCc8CF9j3qq5mecTPdc6YVUPp',
        },
    },
    custom: null,
    hangzhounet: {
        'nameRegistry:set_child_record': {
            address: 'KT1MKZuqHtQreuuG3oGRfE38Z6NkGTjjBF1e',
        },
        'nameRegistry:update_record': {
            address: 'KT1QA8SHmECmpJtY4Q4x2dcFp3F363eB2ecu',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1Bhq5JjNDoPinaYwTaKpai5hJE9qaoyzX6',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1E9dMuV3c82VzP117LdfUXNiM4YHdUvNKj',
        },
        nameRegistry: {
            address: 'KT1T3P8cT3NvbpoxUSx6YVLu3FS7s1XmwvM5',
            resolveProxyContract: true,
        },
        'tldRegistrar:han:commit': {
            address: 'KT1CEX6h5wxXMJ1f24ZZ8woDTmamZqPzcU5x',
        },
        'tldRegistrar:han': {
            address: 'KT1CEX6h5wxXMJ1f24ZZ8woDTmamZqPzcU5x',
            resolveProxyContract: true,
        },
        'tldRegistrar:han:buy': {
            address: 'KT1UdLszZbWarYKvb364dW77Gxi7m74TuAHL',
        },
        'tldRegistrar:han:renew': {
            address: 'KT1LmjcYF4SYZzVdfWSPvowwxabBvVeJm1in',
        },
        'tldRegistrar:han:bid': {
            address: 'KT1J48x7eK7SCW3KyK2fW1fhC6uF8VZGFTHq',
        },
        'tldRegistrar:han:withdraw': {
            address: 'KT1CxrB79RVYuJVqPmBJKLYrPXLgsdJD6sDp',
        },
        'tldRegistrar:han:settle': {
            address: 'KT1M4QHgeVehsgY31toqKRoDqReZkGKAmyxo',
        },
        'tldRegistrar:a1:commit': {
            address: 'KT1QTuxVd81nF2xWQeBv6SD2EmzngRqG34HN',
        },
        'tldRegistrar:a1': {
            address: 'KT1QTuxVd81nF2xWQeBv6SD2EmzngRqG34HN',
            resolveProxyContract: true,
        },
        'tldRegistrar:a1:buy': {
            address: 'KT1RqtMSNDMLMnL34pKi2DjXtkHAnBkzVkBB',
        },
        'tldRegistrar:a1:renew': {
            address: 'KT1PDHn2iqQiEwD7Btfgs3Dv48RELZ3GfHGJ',
        },
        'tldRegistrar:a1:bid': {
            address: 'KT1GvS4cM6atK3qfrk9AhPbrBPLR1AMYaFZF',
        },
        'tldRegistrar:a1:withdraw': {
            address: 'KT1WAuZydJLxySMFsPCZiA8v8zQcJBXgZYHq',
        },
        'tldRegistrar:a1:settle': {
            address: 'KT1S1tJGDCr5dULSXwojU2xdPUYrqLgULrMo',
        },
        'tldRegistrar:a2:commit': {
            address: 'KT1HhLzAYnpa6cA3HYTxrMoPgvEz12APzK6y',
        },
        'tldRegistrar:a2': {
            address: 'KT1HhLzAYnpa6cA3HYTxrMoPgvEz12APzK6y',
            resolveProxyContract: true,
        },
        'tldRegistrar:a2:buy': {
            address: 'KT1XiSycfdmtKsXzJZ9bNi7aSfoEZtuqJrKC',
        },
        'tldRegistrar:a2:renew': {
            address: 'KT1NasLdh1RtRYoEEEH9ikBa6DR4hiTK1bjf',
        },
        'tldRegistrar:a2:bid': {
            address: 'KT1Bi35HxL3htPhUCDeRFx5TrBxgjQX8s2Bc',
        },
        'tldRegistrar:a2:withdraw': {
            address: 'KT1G9yokzRvxwXdE9aoR7HAkhg3eQnQVNGhL',
        },
        'tldRegistrar:a2:settle': {
            address: 'KT1MBRoRhiazhd1eaD9QzDHaXwny8oD9hATh',
        },
        'tldRegistrar:a3:commit': {
            address: 'KT1Hhn1dJxBAvAr9FpyBY2GznVuww9X4KVPn',
        },
        'tldRegistrar:a3': {
            address: 'KT1Hhn1dJxBAvAr9FpyBY2GznVuww9X4KVPn',
            resolveProxyContract: true,
        },
        'tldRegistrar:a3:buy': {
            address: 'KT1NzosgrTRC5MAMJ719ZtgMYe27jqRjfiu2',
        },
        'tldRegistrar:a3:renew': {
            address: 'KT19S7FQJQf9et54D8djUEWoa7WwsLU4uHBW',
        },
        'tldRegistrar:a3:bid': {
            address: 'KT1M5BAQSMpxhfwcZSB6Fk2vxr5kua3uC37t',
        },
        'tldRegistrar:a3:withdraw': {
            address: 'KT1TfNLYKnRm9fhpqqropsmeGjtUpAtyc36R',
        },
        'tldRegistrar:a3:settle': {
            address: 'KT1GiFtoAD5CVuxTHSpeg9FVXDBD7DsDAaSo',
        },
    },
    ithacanet: {
        'nameRegistry:set_child_record': {
            address: 'KT1WX2SYvNMo1onPRfsgBVctYLvkHLRLduxk',
        },
        'nameRegistry:update_record': {
            address: 'KT1WaeAWuyybe5wcW59gsGyGXth1hkSHekNE',
        },
        'nameRegistry:claim_reverse_record': {
            address: 'KT1Ty9HKkUdCu9SvQwVC9o17Nykah7GRKpe1',
        },
        'nameRegistry:update_reverse_record': {
            address: 'KT1DVb3oCwbYQCYofZYGaVkXHYuG3wqYCkPV',
        },
        nameRegistry: {
            address: 'KT1WX2SYvNMo1onPRfsgBVctYLvkHLRLduxk',
            resolveProxyContract: true,
        },
        'tldRegistrar:ith:commit': {
            address: 'KT1WffvKqRGaPtVWYR1ZkG2GQY42B7a8x3kk',
        },
        'tldRegistrar:ith': {
            address: 'KT1WffvKqRGaPtVWYR1ZkG2GQY42B7a8x3kk',
            resolveProxyContract: true,
        },
        'tldRegistrar:ith:buy': {
            address: 'KT1Fea9sCJ4BKjEYHLoEja7JuhXxKZkv9XDp',
        },
        'tldRegistrar:ith:renew': {
            address: 'KT1L6WwTdwkAfCXvtrp9inH3T3wN3UePmrvB',
        },
        'tldRegistrar:ith:bid': {
            address: 'KT1TPySVGH1vq9aSFTW1CpioVpJEwtPCd2Wr',
        },
        'tldRegistrar:ith:withdraw': {
            address: 'KT1C2Sza5PX4DusgUojMg36UZQK5sZV5C9Qz',
        },
        'tldRegistrar:ith:settle': {
            address: 'KT1LPRW7qxN6rcwi9TMGNCG4KKBPU4b5w5XP',
        },
        'tldRegistrar:a1:commit': {
            address: 'KT1F1upxcESQ6KiRqu4FST1UxB2EFLh4hzqK',
        },
        'tldRegistrar:a1': {
            address: 'KT1F1upxcESQ6KiRqu4FST1UxB2EFLh4hzqK',
            resolveProxyContract: true,
        },
        'tldRegistrar:a1:buy': {
            address: 'KT1QPuPb3WuLn2iN6AfsZBoKc87Y7wzMGHyR',
        },
        'tldRegistrar:a1:renew': {
            address: 'KT1CjkJaCCta4SMw9F5ZwTwkFqXyamFjFxTe',
        },
        'tldRegistrar:a1:bid': {
            address: 'KT1FStreKNANRm6qw7SfT3tjohh7gJktKeyW',
        },
        'tldRegistrar:a1:withdraw': {
            address: 'KT1BpjP8JioAiriiVwVx5o1urFERW62E8jr9',
        },
        'tldRegistrar:a1:settle': {
            address: 'KT1SoEdshkevZEdZEMmU8JtY9hveEPtgUkKj',
        },
        'tldRegistrar:a2:commit': {
            address: 'KT1QemkM3qD21PLNAr8TNXocn6kvf1nSt5dY',
        },
        'tldRegistrar:a2': {
            address: 'KT1QemkM3qD21PLNAr8TNXocn6kvf1nSt5dY',
            resolveProxyContract: true,
        },
        'tldRegistrar:a2:buy': {
            address: 'KT1B7uJkC8XPHxAGZXFQjXu62ij1rqqAmRjy',
        },
        'tldRegistrar:a2:renew': {
            address: 'KT19xfTrcAsv9fD3P1HnjFX4gPwwpzZn2aQd',
        },
        'tldRegistrar:a2:bid': {
            address: 'KT1BwtfLRZxKUvpQoZfVv7pFAu2VRLGx3JsR',
        },
        'tldRegistrar:a2:withdraw': {
            address: 'KT1T3T5H5GqH7VWTdhteJYNCdCZFMxXHWWxo',
        },
        'tldRegistrar:a2:settle': {
            address: 'KT1Hq2xAoLM4PzQrJMyFqEUq8dUgYyVPRBW2',
        },
        'tldRegistrar:a3:commit': {
            address: 'KT1DJkgnqcKHtD9dnZTxh5yjsSAKnsgtGAz8',
        },
        'tldRegistrar:a3': {
            address: 'KT1DJkgnqcKHtD9dnZTxh5yjsSAKnsgtGAz8',
            resolveProxyContract: true,
        },
        'tldRegistrar:a3:buy': {
            address: 'KT1MKfCzteVWFBSHEq4pT56bVQZpyDee5XT3',
        },
        'tldRegistrar:a3:renew': {
            address: 'KT1FjHPtr5h7T87Lnh1W87kYnxSMewDrHjdp',
        },
        'tldRegistrar:a3:bid': {
            address: 'KT1KgcYBydkg9DTGRA3FVgHHQFogbBUWAGxu',
        },
        'tldRegistrar:a3:withdraw': {
            address: 'KT1CjJ7oEhYcTyxordL4naxocXRaH69bZegz',
        },
        'tldRegistrar:a3:settle': {
            address: 'KT1W4wuv5zsQS2fvR6wr5GYYRRXjKADLiD66',
        },
        oracleRegistrar: {
            address: 'KT1Kwvtw9XFaqsEB7akfLbV45EyCvzH7vPHE',
        },
    },
};
